import { apiAxios, setApiToken } from '../helpers'
// import Axios from "axios";

export const userService = {
  login,
  logout
}

/**
 * @function login start session users and save token and data users
 * @param {*} username
 * @param {*} password
 */

async function login (username, password) {
  try {
    const response = await apiAxios.post('/users/login', {
      email: username,
      password: password,
      register: 'direct'
    })

    let { user, token, languageDefault } = response.data.data
    // login successful if there's a jwt token in the response
    // store user details and jwt token in local storage to keep user logged in between page refreshes
    setApiToken(token)
    localStorage.setItem('userToken', token)
    localStorage.setItem('roles', JSON.stringify(user.roles))
    delete user.roles
    if (languageDefault) localStorage.setItem('langId', languageDefault)
    localStorage.setItem('user', JSON.stringify(user))
    return response
  } catch (error) {
    //   // auto logout if 401 response returned from api
    logout()
    return Promise.reject(error)
  }
}

/**
 * @function logout close session users and remove token and data user
 */

function logout () {
  // remove user from local storage to log user out
  localStorage.removeItem('userToken')
  localStorage.removeItem('user')
  localStorage.removeItem('roles')
  localStorage.removeItem('permissions')
}
